import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { HOME_ROUTE } from 'src/constants/routes'
import { ProjectsPlaceholderModal } from 'src/components/ProjectsPlaceholderModal/index'
import { ProjectsPage } from 'src/pages/ProjectsPage'
import { useGetProjectsQuery } from 'src/reactQuery/useGetProjectsQuery'

export const ProjectsComingSoonPage: FC = () => {
  const navigate = useNavigate()
  const { data, isLoading } = useGetProjectsQuery()
  const projects = data?.data || []

  const handleClose = () => {
    navigate(HOME_ROUTE, { replace: true })
  }

  if (isLoading) {
    return null
  }

  if (projects.length > 0) {
    return <ProjectsPage />
  }

  return (
    <ProjectsPlaceholderModal
      isOpen
      onClose={handleClose}
      onProjectCreated={() => {
        navigate('/projects', { replace: true })
      }}
    />
  )
}
